export const usageInsightsUrl = 'insights/usage/';
export const mileageRankingUrl = 'insights/mileage_rank/';
export const activityInsightsUrl = 'insights/activity/';
export const alertInsightsUrl = 'insights/alert_events/';
export const chargingLevelsInsightsUrl = 'insights/charging_levels/';
export const energyConsumptionRankingUrl = 'insights/energy_consumption_rank/';
export const zebotUrl = 'insights/zebot/';
